'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const borderRadius = {
	xs: "W-AZv",
	sm: "xHNgX",
	md: "_3O93r",
	lg: "wqZzq",
	xl: "lZ-i9",
	clear: "FN0e8"
};
const marginBottom = {
	xxTiny: "yv5Gb",
	xTiny: "vhBKN",
	tiny: "dP7uk",
	xs: "vafki",
	sm: "c6nOw",
	md: "IAwlC",
	lg: "rcL41",
	xl: "-Yfbv",
	xxl: "y0pF-",
	clear: "KieKW"
};

exports.borderRadius = borderRadius;
exports.marginBottom = marginBottom;
